import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DataGrid from 'app/components/DataGrid';
import useSalesReport from 'app/hooks/useSalesReport';
import useDeeplink from 'app/hooks/useDeeplink';

import {
  AND_OPERATOR,
} from 'app/hooks/useFilter';

import {
  formatCurrency
} from 'app/utils/valueFormatters';

import {
  getSalesReport
} from 'app/services/reports';

import {
  moments
} from 'app/resources';

const SalesReport = () => {
  const header = 'Sales Report';
  const deeplink = useDeeplink();

  const {
    resource,
    onDataGridLoad,
    showFilters,
    getRowData,
    getFilterModel
  } = useSalesReport();

  const exportCSV = () => {
    let params = {
      page: 1,
      per_page: 1000,
      is_export: true
    }

    const filterModel = getFilterModel();
    if (filterModel) {
      params.filter_model = filterModel;
    }

    params.selected_dropdown_filter = { key: 'SALES_REPORT', value: 'SALES_REPORT', label: 'Sales Report' }

    getSalesReport(params).then((resp => resp.blob())).then((blob) => {
      const elem = window.document.createElement('a');
      elem.href = window.URL.createObjectURL(blob);
      elem.download = `sales_report_${new Date().toISOString()}.csv`;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    })
  }

  const getSalesReportColumns = () => {
    return [
      {
        field: 'transaction_date',
        headerName: 'Trans Rec Date',
        formatType: 'date',
        inputType: 'date'
      },
      {
        field: 'transaction_id',
        headerName: 'Trans ID',
        inputType: 'number',
      },
      {
        field: 'source',
        headerName: 'Source',
        filterDisabled: true,
      },
      {
        field: 'quantity',
        headerName: 'Quantity',
        inputType: 'number',
        cellRenderer: params => {
          let data = params.data;
          if (data) {
            let filterModel = {
              purchase_id: [{
                filterClass: 'text',
                filterType: 'equals',
                value: data.transaction_id.toString(),
                operator: AND_OPERATOR
              }]
            }
            const link = deeplink.getLink(moments, filterModel);
            return <a href={link} target='_blank'>{data.quantity}</a>;
          }
          return '';
        }
      },
      {
        field: 'total',
        headerName: 'Total',
        inputType: 'number',
        dataValueFormatter: (data, value) => {
          return formatCurrency(value, data.stripe_currency);
        },
      },
      {
        field: 'user_email',
        headerName: 'Email'
      },
      {
        field: 'branchlink_url',
        headerName: 'Digital Link'
      }
    ]
  }

  const columnDefOverrides = getSalesReportColumns();
  const columnOrder = columnDefOverrides.map((column) => column.field);
  const visibleColumns = [].concat(columnOrder);

  const buttons = [
    {
      key: 'export',
      icon: <FileDownloadIcon />,
      label: 'Export CSV',
      onClick: exportCSV
    }
  ]

  return <div>
    <DataGrid
      header={header}
      resource={resource}
      defaultDropdownOption={{ key: 'SALES_REPORT', value: 'SALES_REPORT', label: 'Sales Report' }}
      showDropDown={false}
      getRowData={getRowData}
      showFilters={showFilters}
      onDataGridLoad={onDataGridLoad}
      columnOrder={columnOrder}
      columnDefOverrides={columnDefOverrides}
      visibleColumns={visibleColumns}
      loadingMessage="Loading report..."
      buttons={buttons}
    />
  </div>
}

export default SalesReport;
